import React from "react"
import "./DocumentCard.scss"
interface DocumenType {
  img?: any
  text?: string
  onClick?: any
}
function DocumentCard({ img, text, onClick }: DocumenType) {
  return (
    <div className="document" onClick={onClick}>
      <div className="document-image">
        <img src={img} alt="" />
      </div>
      <div className="document-text">{text}</div>
    </div>
  )
}

export default DocumentCard
